import React, {PureComponent} from 'react';
import {Redirect, Route, Switch} from 'react-router';
import {Router} from 'react-router-dom';
import {connect} from 'react-redux';
import {applicationHistory} from '../common/application-history';
import asyncComponent from '../common/components/async-component';
import Navigation from '../navigation/components/navigation';
import {PrivateRoute} from './private-route';

import ApplicationRoutes from './application-routes';
import ErrorRoutes from './error-routes';
import SnapFishRoute from './snapfish-route';


import MultiViewHeader from '../header/components/multi-view-header';
import HeaderMenu from '../header/components/header-menu';
import Typekit from 'react-typekit';
import AppDownload from '../static/components/app-download';
import UploadController from '../uploadController/components/uploadController-container'
import Preloader from '../preloader/components/preloader';
import InfoPanel from '../infoPanel/components/infoPanel';
import UrlMappings from "../common/url-mappings"
import {leftNavigationHide, leftNavigationShow, updateWindowDimensions} from "../settings/actions/application-actions"
import ConfirmationDialog from "../common/components/confirmation-dialog";
import {ToastContainer, Zoom} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {unregister as unregisterServiceWorker} from '../registerServiceWorker'
import AlertDialog from "../common/components/alert-dialog";

//Signup
const asyncSignup = asyncComponent(() => import('../signup/components/signup'));
const asyncSignupCA = asyncComponent( () => import('../signup/components/signup-ca'))
const asyncResetPassword = asyncComponent(() => import('../signup/components/reset-password'));
const asyncForgotPassword = asyncComponent(() => import('../signup/components/forgot-password'));
const asyncAppDownload = asyncComponent(() => import('../static/components/app-download'));

const asyncActiveLandingPage = asyncComponent(() => import('../activate/components/activate-landing-page'));
const asyncActivePasswordReset = asyncComponent(() => import('../activate/components/activate-password-reset'));
const asyncActiveActivateEmailSent = asyncComponent(() => import('../activate/components/activate-activate-email-sent'));

const asyncUnsubscribe = asyncComponent(() => import('../account/components/unsubscribe'));

class BaseRoute extends PureComponent {
    constructor(props) {
        super(props);
        this.logout = this.logout.bind(this);
        this.openLogoutContent = this.openLogoutContent.bind(this);
        this.showLeftNavIfNecessary = this.showLeftNavIfNecessary.bind(this);
        this.openLogoutContent = -this.openLogoutContent.bind(this);
        this.updateWindowSize = this.updateWindowSize.bind(this);
        applicationHistory.listen(this.showLeftNavIfNecessary);
        this.showLeftNavIfNecessary(applicationHistory.location, null);
        this.state = {
            isLogoutDialogOpen: false
        }
    }

    showLeftNavIfNecessary(location, action) {
        if (location.pathname.indexOf("/my/album/") > -1 ||
            location.pathname.indexOf("/my/view/") > -1 ||
            location.pathname.indexOf("/my/disc/") > -1
            // location.pathname.indexOf("/my/disc-wizard") > -1
        ) {
            this.props.showLeftNav(leftNavigationHide());
        } else {
            this.props.showLeftNav(leftNavigationShow());
        }
    }

    updateWindowSize() {
        const {updateWindowDimensions} = this.props;
        updateWindowDimensions(window.innerWidth, window.innerHeight);
    }

    navigateHome() {
        applicationHistory.push('/');
    }

    logout() {
        this.setState({isLogoutDialogOpen: false});

        // remove any tokens we're keeping in localStorage
        window.localStorage.removeItem('authorization_token');
        window.localStorage.removeItem('authorizationState');
        window.localStorage.removeItem('initialLoginRefresh');
        window.localStorage.removeItem('ocTokenFailed');
        window.sessionStorage.clear();
        this.props.logoutRedux();
        unregisterServiceWorker();

        // build the CAS uri
        const serviceParam = `https://www.imemories.com/`;
        const logoutUri = `${process.env.REACT_APP_CAS_LOGOUT_URI}?service=${serviceParam}`;

        // send the user to CAS which will redirect to the imemories home page
        window.location = logoutUri;
    }

    openLogoutContent() {
        this.setState({isLogoutDialogOpen: true})
    }

    componentDidMount() {
        this.updateWindowSize()
        window.addEventListener('resize', this.updateWindowSize);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowSize);
    }

    render() {
        const contentStyle = {
            transition: 'margin-right 450ms cubic-bezier(0.23, 1, 0.32, 1)',
            marginRight: '256px'
        };

        if (this.props.rightOpen) {
            contentStyle.marginRight = '256px';
        }
        return (
            <Router history={applicationHistory} ref={router => (this.currentRouter = router)}>
                <div>
                    <Typekit kitId="lzx7dzy"/>
                    <div>
                        <HeaderMenu ref={headerMenu => (this.headerMenu = headerMenu)}
                                    openLogoutDialog={() => this.setState({isLogoutDialogOpen: true})}/>
                        <MultiViewHeader
                            {...this.props}
                            router={this.currentRouter}
                            headerMenu={this.headerMenu}
                            navigateHome={this.navigateHome}
                        />
                        <Switch>

                            {this.props.photoCount != -1 ? <Redirect exact from="/" to="/signup"/> :
                                <Redirect exact from="/" to={"/my/albums?ts=" + new Date().getTime()}/>}
                            <Route path="/error/">
                                <ErrorRoutes {...this.props} />
                            </Route>

                            <Route exact path="/signup" component={asyncSignup} {...this.props} />
                            <Route exact path="/signup-ca" component={asyncSignupCA} {...this.props} />
                            <Route exact path="/reset-password" component={asyncResetPassword}/>
                            <Route exact path="/forgot-password" component={asyncForgotPassword}/>
                            <Route exact path="/forgot-password/:uuid" component={asyncResetPassword} {...this.props} />
                            <Route exact path="/app-download" component={asyncAppDownload} {...this.props}/>
                            <Route exact path="/unsubscribe" component={asyncUnsubscribe} {...this.props}/>

                            {/* Lifetouch Portrait Studio Routes */}
                            <Route exact path={UrlMappings.ACTIVATE}
                                   component={asyncActiveLandingPage} {...this.props} />
                            <Route exact path={UrlMappings.ACTIVATE_THANK_YOU}
                                   component={asyncActiveActivateEmailSent} {...this.props} />
                            <Route exact path={UrlMappings.ACTIVATE_PWR}
                                   component={asyncActivePasswordReset} {...this.props} />

                            <PrivateRoute path="/my/" {...this.props}>
                                <div>
                                    <InfoPanel/>
                                    <div
                                        id="content-layout"
                                        className="default-content-layout"
                                        ref={calculationElement => (this.calculationElement = calculationElement)}>

                                        <div className="left-nav" role="navigation" style={contentStyle}>


                                            {this.props.leftNavigationShown && <Navigation {...this.props} />}


                                        </div>
                                        <div className="right-side">
                                            <ApplicationRoutes {...this.props}
                                                               calculationElement={this.calculationElement}/>
                                        </div>

                                    </div>
                                </div>
                            </PrivateRoute>

                            <PrivateRoute path="/">
                                <Route path="/app-download" render={appDownloadContent}/>
                            </PrivateRoute>
                            <PrivateRoute>
                                <Route exact path="/snapfish" render={renderSnapFish}/>
                            </PrivateRoute>
                        </Switch>
                    </div>
                    {this.state.isLogoutDialogOpen &&
                        <ConfirmationDialog title={"Confirm Sign out"}
                                            message={"Are you sure you want to sign out?"}
                                            isOpen={this.state.isLogoutDialogOpen}
                                            onYesAction={this.logout}
                                            onNoAction={() => this.setState({isLogoutDialogOpen: false})}/>
                    }

                    {this.props.photoCount != -1 ? <UploadController/> : null}
                    <Preloader/>
                    <ToastContainer position={"top-center"}
                                    className="toast-main top-center"
                                    transition={Zoom}
                                    bodyClassName="toast-body"
                                    hideProgressBar={true}
                                    closeButton={false}
                                    autoClose={3000}
                                    closeOnClick={false}
                                    draggable={false}
                                    toastClassName="toast-inner-container"/>
                    {this.props.alertDialog.isOpen && <AlertDialog {...this.props.alertDialog}/>}
                    {this.props.confirmDialog.isOpen && <ConfirmationDialog {...this.props.confirmDialog} />}
                </div>
            </Router>
        );
    }
}

const mapStateToProps = state => {
    return {
        customer: state.profile.customer,
        photoCount: state.profile.photoCount,
        videoCount: state.profile.videoCount,
        lastCustomerRequest: state.profile.lastCustomerRequest,
        lastStorageRequest: state.profile.lastStorageRequest,
        lastStatsRequest: state.profile.lastStatsRequest,
        leftNavigationShown: state.applicationState.leftNavigation,
        rightOpen: state.albumImages.rightOpen,
        cart: state.cart,
        userSubscriptionExpired: state.applicationState.userSubscriptionExpired,
        maintenanceMode: state.settings.systemProps["system.maintenance"] === true,
        maintenanceMessage: state.settings.systemProps["system.maintenance.message"] || "This system is currently undergoing routine maintenance.  Please check back later.",
        allowDownload: (state.cart.cartDataReceived && state.cart.orderType !== "RPC") && (state.settings.attributes["web.download.allow"] == null || state.settings.attributes["web.download.allow"] !== "false"),
        alertDialog: state.dialog.alertDialog,
        confirmDialog: state.dialog.confirmDialog
    };
};

const mapDispatchToProps = dispatch => {
    return {
        showLeftNav: action => dispatch(action),
        updateWindowDimensions: (width, height) => dispatch(updateWindowDimensions(width, height)),
        logoutRedux: () => dispatch({type: "USER_LOGOUT"})

    };
};

export default connect(mapStateToProps, mapDispatchToProps)(BaseRoute);

const renderSnapFish = props => {
    return (
        <SnapFishRoute
            successCallback={obj => {
                console.log('selected objects', obj);
            }}
            failureCallback={err => {
                console.log('error', err);
            }}
            closeCallback={() => {
                console.log('close called');
            }}
            removePicker={() => {
                console.log('picker removed!, not really');
            }}
        />
    );
};

const appDownloadContent = () => {
    return (
        <div className="default-content-layout">
            <div className="left-nav" role="navigation">
                <Navigation {...this.props} />
            </div>
            <div className="right-side">
                <AppDownload {...this.props} />
            </div>
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/routes/base-route.jsx